enum ERequestStatus {
  IDLE,
  PENDING,
  RESOLVED,
  REJECTED,
};

export default ERequestStatus;